// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"2112b40b","237":"277f55f6","271":"d4f23803","381":"779288af","446":"5d7b733e","778":"18e742d9","787":"0eeaa2ab"}[chunkId] + ".chunk.js";
};